import { render, staticRenderFns } from "./trans-lands.html?vue&type=template&id=2e1ccfe1&scoped=true&external"
import script from "./trans-lands.js?vue&type=script&lang=js&external"
export * from "./trans-lands.js?vue&type=script&lang=js&external"
import style0 from "./trans-lands.scss?vue&type=style&index=0&id=2e1ccfe1&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1ccfe1",
  null
  
)

export default component.exports